export default __webpack_public_path__ + "static/media/chains_of_the_dandelion_gladiator.a6e8d9a5.png";